// src/components/Login.js
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { markSessionActivity } from '../utils/sessionManager';
function Login() {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  // If already logged in, go to dashboard
  // useEffect(() => {
  //   const token = localStorage.getItem('session_token');
  //   const userData = localStorage.getItem('user_data');
  //   if (token && userData) {
  //     navigate('/dashboard', { replace: true });
  //   }
//  useEffect(() => {
//   const logoutReason = sessionStorage.getItem('session_logout_reason');

//   if (logoutReason === 'idle_timeout') {
//     toast.error(
//       'Session expired due to inactivity. Please login again.',
//       {
//         position: 'top-center',
//         autoClose: 2000,   // ✅ 2 seconds
//         pauseOnHover: false, // optional: keeps timing strict
//         closeOnClick: true,
//       }
//     );

//     sessionStorage.removeItem('session_logout_reason');
//   }

//   const token = localStorage.getItem('session_token');
//   const userData = localStorage.getItem('user_data');

//   if (token && userData) {
//     navigate('/dashboard', { replace: true });
//   }
// }, [navigate]);
useEffect(() => {
  const logoutReason = sessionStorage.getItem('session_logout_reason');

  if (logoutReason === 'idle_timeout') {
    toast.error(
      'Session expired due to inactivity. Please login again.',
      {
        autoClose: 2000,
        pauseOnHover: false,
      }
    );

    sessionStorage.removeItem('session_logout_reason');
  }

  const token = localStorage.getItem('session_token');
  const userData = localStorage.getItem('user_data');

  if (token && userData) {
    setTimeout(() => {
      navigate('/dashboard', { replace: true });
    }, 2100); // wait for toast
  }
}, [navigate]);
  const safeParseJson = async (response) => {
    const ct = response.headers.get('content-type') || '';
    if (!ct.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Unexpected response type: ${ct} ${text.slice(0, 120)}`);
    }
    return response.json();
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://newerp.awasthivitality.com/api/patient/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          user_name: userName,
          password: password,
        }),
      });

      // const data = await safeParseJson(response);

      // if (response.ok && data.success) {
      //   // Save Bearer token + user
      //   localStorage.setItem('session_token', data.token);
      //   localStorage.setItem('user_data', JSON.stringify(data.user));
const data = await safeParseJson(response);

      if (response.ok && data.success) {
        // OLD LOGIN STORE LOGIC
        // localStorage.setItem('session_token', data.token);
        // localStorage.setItem('user_data', JSON.stringify(data.user));

        // NEW LOGIN STORE LOGIC (includes idle-time config from backend)
        localStorage.setItem('session_token', data.token);
        localStorage.setItem('user_data', JSON.stringify(data.user));
        localStorage.setItem('auto_logout_minutes', String(data.auto_logout_minutes || 30));
        markSessionActivity();
        sessionStorage.removeItem('session_logout_reason');
        // Fetch permissions and store with user_data for later permission checks
        try {
          const permUrl = `https://newerp.awasthivitality.com/api/user/permissions?token=${encodeURIComponent(data.token)}`;
          const permRes = await fetch(permUrl, {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          });

          const permData = await safeParseJson(permRes);

          // Normalize and attach permissions if available
          const currentUser = JSON.parse(localStorage.getItem('user_data') || '{}');
          const permissions =
            permData.permissions ||       // some APIs return { success, permissions: {...} }
            permData.data ||              // others return { success, data: {...} }
            currentUser.permission || {}; // fallback to whatever came from login

          localStorage.setItem('user_data', JSON.stringify({
            ...currentUser,
            permission: permissions
          }));
        } catch (permErr) {
          // Non-fatal; allow login but warn
          console.warn('Permission fetch failed:', permErr);
        }

        toast.success(`Welcome back, ${data.user.user_name}!`, {
          position: 'top-center',
          autoClose: 1500,
        });

        navigate('/dashboard', { replace: true });
      } else {
        const message =
          (data?.errors && Object.values(data.errors).flat().join(', ')) ||
          data?.message ||
          'Login failed. Please try again.';
        toast.error(message, { position: 'top-center', autoClose: 3000 });
      }
    } catch (err) {
      toast.error('Network/response error. Please try later.', {
        position: 'top-center',
        autoClose: 3000,
      });
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 bg-light"
      style={{
        backgroundImage: "url('img/hospital.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="card shadow-lg p-4" style={{ width: '100%', maxWidth: 400, borderRadius: 16 }}>
        <div className="text-center mb-4">
          <img src="img/logo.png" alt="Hospital Icon" />
          <h3 className="mt-2 text-danger">Hospital Login</h3>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">User Name</label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="bi bi-person"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your username"
                required
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                disabled={loading}
                autoComplete="username"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Password</label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="bi bi-lock"></i>
              </span>
              <input
                type="password"
                className="form-control"
                placeholder="••••••••"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                autoComplete="current-password"
              />
            </div>
          </div>

          <button type="submit" className="btn btn-danger w-100" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Logging in...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-1"></i> Login
              </>
            )}
          </button>
        </form>

        <p className="text-center mt-3 mb-0 text-muted" style={{ fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} Awasthi Vitality. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Login;